import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const DashboardProtectedRoute = ({ user, access, children }) => {

    const dirWebApp = process.env.REACT_APP_DIR_PRO

    const validarUser = useSelector(state => state.auth.IdEmp)

    const modalAdmisiones = JSON.parse(localStorage.getItem('showAdmisiones'))
    if (modalAdmisiones) {
        return <Navigate to={`${dirWebApp}admisiones`} replace />        
    } else {
        if (!user) {
            return <Navigate to={`${dirWebApp}login`} replace />
        }
        else {
            if (validarUser === 'PPUBLIC001') {
                return <Navigate to={`${dirWebApp}login`} replace />
            } else {
                return children
            }
        }
    }
}

export default DashboardProtectedRoute